import { render, staticRenderFns } from "./orderManager.vue?vue&type=template&id=74c40f3e&scoped=true"
import script from "./orderManager.vue?vue&type=script&lang=ts"
export * from "./orderManager.vue?vue&type=script&lang=ts"
import style0 from "./orderManager.vue?vue&type=style&index=0&id=74c40f3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c40f3e",
  null
  
)

export default component.exports